import { mediaImageFilters } from '@/filters/mediaImage';
export default class AddToMarkup {
    config() {
        return {
            title: 'Add item to markup',
            description: 'Choose an existing item to markup.',
            mode: 'single',
            media: true,
            sets: false,
            upload: {
                allow: false,
            },
            defaultFilters: [
                { type: 'image' },
                { 360: false },
                { comments: false },
                { interactive_id: null },
                { public: null },
            ],
            filterOptions: mediaImageFilters,
        };
    }
    doAction() {
        return new Promise((resolve) => {
            const items = App.$store.getters.getMediaSelectSelected;
            const id = items.pop().id;
            resolve(id);
        });
    }
}
